module.exports = __webpack_public_path__ + "media/images/svg/clients/19-ade99ca06f88d6948cdf8b7d63a16151.svg";